import React from "react";

import LexiqueCard from "./LexiqueCard";

function LexiqueList({ groupedLexique = [] }) {
  return (
    <div className="mt-6 space-y-6">
      {groupedLexique.map((group) => (
        <section
          key={group.letter}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
        >
          <div className="flex items-center justify-between gap-4 border-b border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.03] sm:p-5">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-100 text-xl font-bold text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200">
                {group.letter}
              </div>

              <div>
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
                  Lettre
                </p>

                <h2 className="font-titre text-2xl font-bold text-slate-950 dark:text-white">
                  {group.letter === "#" ? "Autres termes" : `Termes en ${group.letter}`}
                </h2>
              </div>
            </div>

            <span className="rounded-full bg-white px-3 py-1 text-xs font-bold text-slate-500 shadow-sm dark:bg-white/10 dark:text-white/60">
              {group.items.length} terme{group.items.length > 1 ? "s" : ""}
            </span>
          </div>

          <div className="grid gap-3 p-4 sm:p-5 md:grid-cols-2 xl:grid-cols-3">
            {group.items.map((item) => (
              <LexiqueCard key={item.__key} item={item} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default LexiqueList;